import { TextField } from "@overmap-ai/forms"
import type { ReactNode } from "react"

import {
	NullableStringEqualsFilterModifier,
	NullableStringNotEqualsFilterModifier,
	StringExcludesFilterModifier,
	StringIncludesFilterModifier,
} from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { TextFieldFilterCell } from "./TextFieldFilterCell"

type TextFieldValue = string | null
type TextFilterValue = string | null

export class TextFieldFilterDef extends BaseFilterDef<TextFieldValue, TextFilterValue> {
	readonly id: string
	readonly defaultFilterValue: TextFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"

	readonly field: TextField

	constructor(field: TextField) {
		super()
		this.field = field
		this.id = field.id
	}

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableStringEqualsFilterModifier,
			isValueValid: (_value: TextFieldValue): _value is string => true,
			isFilterValueValid: (_filterValue: TextFilterValue): _filterValue is string | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: NullableStringNotEqualsFilterModifier,
			isValueValid: (value: TextFieldValue): value is string => value !== null,
			isFilterValueValid: (_filterValue: TextFilterValue): _filterValue is string | null => true,
		}),
		includes: createFilterModifierConfig({
			modifier: StringIncludesFilterModifier,
			isValueValid: (value: TextFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: TextFilterValue): filterValue is string => filterValue !== null,
		}),
		excludes: createFilterModifierConfig({
			modifier: StringExcludesFilterModifier,
			isValueValid: (value: TextFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: TextFilterValue): filterValue is string => filterValue !== null,
		}),
	}

	render(props: FilterDefRenderProps<TextFieldFilterDef>): ReactNode {
		return <TextFieldFilterCell key={props.filter.id} field={this.field} {...props} />
	}
}
